 
import Form from 'react-bootstrap/Form';
import SignIn from './SignIn' 
function Login() {
return (
<Form as="div" className="login-bg">
    <Form as="div" className="login-container w-100 w-md-50 mx-auto">       
      <SignIn/>
    </Form>
</Form>
);
}
export default Login;